module.exports = __webpack_public_path__ + "img/onboarding-ref.23dc0e38.svg";